import { LinkedIn } from '@mui/icons-material'
import React from 'react'
import { FcPhone } from 'react-icons/fc'
import { RiWhatsappFill } from 'react-icons/ri'
import gmailIcon from '../../assets/gmailLogo.png'
import { motion } from 'framer-motion'

import img1 from '../../assets/eng1.svg'
import img2 from '../../assets/eng2.svg'
import img3 from '../../assets/eng3.svg'
import logo from '../../assets/logo.jpeg'
import { fadeIn, staggerContainer } from '../../utils/motion'
import { useNavigate } from 'react-router-dom'
import StatisticsForm from './StatisticsForm'


const StatisticsHeader = () => {

    let icons = [
        {
            icon: <RiWhatsappFill className='h-[23px] text-green-500' />,
            link: 'https://wa.me/+923250719500 '
        },

        {
            icon: <LinkedIn sx={{ fontSize: '23px', color: '#1976d2' }} />,
            link: 'https://www.linkedin.com/in/code-zone-2222a5260'
        },
        {
            icon: <img src={gmailIcon} className='h-[23px]' alt='img' />,
            link: 'mailto:codezone546@gmail.com'
        },
        {
            icon: <FcPhone className='h-[23px]' />,
            link: 'tel:+92(325) 071-9500'
        },
    ]

    const data = [
        {
            title: 'Staff/Resource Augmentation',
            img: img1,
            desc: 'Our staff augmentation model is intended to help companies find the right skills for their project.'
        },
        {
            title: 'Product Development',
            img: img2,
            desc: 'The project-based model is designed to help you get your product built from ideation to deployment by a team of expert software engineering consultants.'
        },
        {
            title: 'Dedicated Development Team',
            img: img3,
            desc: 'Our team of developers is highly qualified and dedicated to delivering quality development services to clients.'
        },
    ]

    const navigate = useNavigate()

    return (
        <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
        >
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6 md:mt-10'>
                <div>
                    <h1 className='font-bold text-xl text-center md:text-left dark:text-white'>Talk to our <span className='text-yellow-500'>Sales Team</span></h1>

                    <div className='group mt-3 md:mt-0'>
                        <div className='flex md:group-hover:translate-x-5 duration-[850ms] items-center justify-center md:justify-start gap-2 my-2 md:my-4 rounded-md bg-slate-700 shadow-md lg:w-[90%] p-3'>
                            <div className=' my-3 hover:scale-90 duration-700'>
                                <img src={logo} alt="logo"
                                    className='h-[60px] md:h-[70px] w-[60px] md:w-[70px] rounded-tl-[50px] rounded-tr-[50px] rounded-bl-[50px] rounded-br-[90px]' />
                            </div>
                            <div className='grow flex justify-center'>
                                <div className='flex gap-2 '>
                                    <div className='hidden sm:flex'>
                                        <div className='h-[50px] w-[50px] hover:scale-90 duration-700 opacity-90 border-[2px] md:border-[4px] border-gray-200 rounded-tl-[50px] rounded-tr-[50px] rounded-bl-[50px] rounded-br-[80px] flex justify-center items-center'>
                                            <h1 className='text-[19px] font-semibold text-white'>
                                                C<span className='text-green-500'>Z</span>
                                            </h1>
                                        </div>
                                    </div>
                                    <div>
                                        <h1 className='font-bold text-lg text-white '>Code<span className='text-green-500'>Zone</span></h1>
                                        <div className=' flex items-center gap-2 '>
                                            {icons.map((item, i) => {
                                                return <div
                                                    key={i}
                                                    onClick={() => window.open(item.link)}
                                                    className={'w-[40px] relative group h-[40px] rounded-full flex justify-center items-center bg-gray-100 cursor-pointer hover:scale-90 duration-700 hover:white-shadow'}
                                                >
                                                    {item.icon}
                                                    <span id='k' className="group-hover:ping-once absolute rounded-full bg-slate-500 -z-20 duration-[800ms] opacity-75"></span>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className='lg:w-[90%]  mt-4'>

                        <div className='space-y-4'>
                            {data.map((item, i) => {

                                let x
                                if (i === 0) {
                                    x = 0.2
                                } else if (i === 1) {
                                    x = 0.4

                                } else if (i === 2) {
                                    x = 0.6
                                }
                                return <motion.div
                                    variants={fadeIn('right', 'tween', x, 1.3)}
                                    className='flex items-center justify-center group'
                                    key={i}
                                >
                                    <div
                                        onClick={() => navigate('/pricing')}
                                        className={`bg-white rounded-md cursor-pointer shadow-md min-h-[150px] dark:bg-slate-700 p-3 flex items-center gap-3 md:group-hover:translate-x-5 duration-[850ms]`} >
                                        <div>
                                            <img src={item.img} alt="img" className='h-[70px] w-[70px] group-hover:scale-110 duration-700' />
                                        </div>
                                        <div>
                                            <h1 className='font-bold dark:text-white text-[15px] sm:text-[17px]'>
                                                {item.title}
                                            </h1>
                                            <p className='mt-1 text-[12px] sm:text-[15px] text-gray-500 dark:text-gray-300'>{item.desc}</p>
                                        </div>
                                    </div>
                                </motion.div>
                            })}
                        </div>
                    </div>

                </div>
                <div>
                    <h6 className='text-sm text-gray-500 dark:text-gray-300'>
                        We are passionate about delivering great software and services.
                    </h6>
                    <StatisticsForm />
                </div>
            </div>
        </motion.div >
    )
}

export default StatisticsHeader